import { z } from "zod";

export const editFileFormSchema = z.object({
  category: z.string().optional(),
  eoc: z.string().optional(),
  file: z.instanceof(globalThis.File).nullable(),
  filename: z.string().optional(),
});

export type EditFileForm = z.infer<typeof editFileFormSchema>;

export const newFileSchema = z.object({
  category: z.string().min(1, "Required"),
  eoc: z.string().optional(),
  file: z.instanceof(globalThis.File),
});

export type NewFileForm = z.infer<typeof newFileSchema>;
